import React, {Component} from "react";
import {Alert, Button, Col, Container, Form, Jumbotron, Row} from "react-bootstrap";
import Axios from "axios";
import {GetUser} from "../helpers/User";
import Footer from "../Footer";
import {Link} from "react-router-dom";

export default class AccountView extends Component {
    state ={};
    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        data.append("firstName",form["firstName"].value);
        data.append("lastName",form["lastName"].value);
        data.append("company",form["company"].value);
        data.append("companyImg",form["companyImg"].value);
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/users/account", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            this.setState({alert:{
                    title:"Account Updated!",
                    body:"The account info has been successfully updated."
                }});
            setTimeout(()=>this.setState({
                alert: null
            }),3000)
        }).catch(error => {
            this.setState({error:{
                    title:"Server Reported an error",
                    body:error.responseText,
                }});
            setTimeout(()=>this.setState({
                error: null
            }),3000)
        });
    };
    componentDidMount() {
        GetUser().then(user =>{
            this.setState({user:user});
        })
    }

    render() {
        let user = this.state.user;
        return  <div className={"main-container"}>
            <Container>
                <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5"}>
                    <Form onSubmit={this.onSubmit}>
                        <Row className={"mb-4"}>
                            <Col>
                                <h2>Account</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="firstName">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" defaultValue={user ? user.firstName :""} required/>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="lastName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" defaultValue={user ? user.lastName: ""} required/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="text" defaultValue={user ? user.email : ""} required readOnly/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="company">
                                    <Form.Label>Company</Form.Label>
                                    <Form.Control type="text" defaultValue={user ? user.company : ""}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="companyImg">
                                    <Form.Label>Company Logo URL</Form.Label>
                                    <Form.Control type="text" defaultValue={user ? user.companyImg : ""}/>
                                    <i>Whitelist the campaign view.</i>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className={"mt-4"}>
                            <Col>
                                <Button variant="primary" type={"submit"}>
                                    Update Account
                                </Button>
                            </Col>
                            <Col className={"text-right"}>
                                <div className={"mt-1 mr-4"}>
                                    <Link to={"/logout"} className={"boring-btn"}>Logout</Link>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Jumbotron>
                <div className={"mx-auto mt-5"}>
                </div>
                {this.state.alert ? (
                    <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="success" onClose={()=>{this.setState({alert: null})}} dismissible>
                        <Alert.Heading>{this.state.alert.title}</Alert.Heading>
                        <p>{this.state.alert.body}</p>
                    </Alert>
                ):(
                    <></>
                )}
                {this.state.error ? (
                    <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="danger" onClose={()=>{this.setState({error: null})}} dismissible>
                        <Alert.Heading>{this.state.error.title}</Alert.Heading>
                        <p>{this.state.error.body}</p>
                    </Alert>
                ):(
                    <></>
                )}
                <Footer/>
            </Container>
        </div>
    }
}
